import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { currentUserSubject } from '@common/services/user.service';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { DialogCloseResult, DialogRef } from '@progress/kendo-angular-dialog';
import { ToastService } from '@services/toast.service';
import { filter } from 'rxjs';
import { MessageService } from '../message.service';

@Component({
    selector: 'app-message-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageModalComponent {
    public messageId: string;
    public messageNumber: string;
    public messageData: string;
    public errorMessage: string;
    public title: string;
    public canResend = false;
    public resendButtonVisible: boolean;

    constructor(
        public activeModal: DialogRef,
        private translateService: TranslateService,
        private dialogService: ModalService,
        private service: MessageService,
        private toastyService: ToastService
    ) {
        this.canResend = this.hasPermission('Administration.Messages.Resend');
    }

    resend() {
        this.dialogService
            .confirm(
                this.translateService.instant(marker('Resend message')),
                this.translateService.instant(marker('Are you sure you want to resend the message?')),
                this.translateService.instant(marker('Yes')),
                null,
                this.translateService.instant(marker('Cancel'))
            )
            .pipe(filter((x) => !(x instanceof DialogCloseResult)))
            .subscribe((dialogResult) => {
                if (dialogResult) {
                    this.service.resendMessage(+this.messageId).subscribe((res) => {
                        if (res) {
                            this.toastyService.success(this.translateService.instant(marker('Message resent.')));
                            this.activeModal.close(this.messageId);
                        }
                    });
                }
            });
    }

    private hasPermission(fullPermissionName: string) {
        const user = currentUserSubject.getValue();
        if (!user) {
            return false;
        }

        return user.hasPermission(fullPermissionName);
    }
}
